"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Layouts = require("layouts");
var Snippets = require("snippets");
var AccountOrderTemplate = /** @class */ (function (_super) {
    __extends(AccountOrderTemplate, _super);
    function AccountOrderTemplate() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.order = _this.props.data.order;
        _this.refunds = _this.order.transactions.filter(function (item) { return item.kind == "refund"; });
        _this.transactions = _this.order.transactions.filter(function (item) { return item.kind == "sale"; });
        return _this;
    }
    AccountOrderTemplate.prototype.render = function () {
        var header = "pt-0-8 pb-1-6 text-charcoal text-base border-b leading-normal";
        var contentBlock = "bg-arctic-grey-mid px-1-6 py-1-6 md:pb-3-2";
        return (React.createElement(Layouts.Theme, __assign({}, this.props),
            React.createElement(Snippets.AccountFrame, __assign({}, this.props, { title: "Order Details" }),
                React.createElement(Snippets.AccountCard, { title: " " },
                    React.createElement(Snippets.Card, { className: "rounded" },
                        React.createElement("div", { className: "w-full" },
                            React.createElement(Snippets.Order, { order: this.order, onClick: null })))),
                React.createElement("div", { className: "mt-2-4 pt-2-4 text-center md:text-left" },
                    React.createElement("a", { className: "uppercase text-charcoal text-sm  font-normal tracking-widest leading-normal px-1-2", href: "/account?view=orders" },
                        React.createElement(Snippets.Svg, { name: "arrow-right", height: 12, className: "mr-0-8 rotate-180" }),
                        React.createElement("span", null, "Back to Order History"))))));
    };
    return AccountOrderTemplate;
}(React.Component));
exports.AccountOrderTemplate = AccountOrderTemplate;
